// form
import React, { useState } from 'react';
// @mui
import { Box, Stack, Typography, Divider, RadioGroup, Tooltip } from '@mui/material';
import SvgColor from '../../../components/svg-color';
import { MaskControl, StyledCard, StyledWrap } from './styles';
// import Block from 'src/components/block/Block';
import _ from 'lodash';
import AddFinancial from './AddFinancial';
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function PaymentAccounts({ options, formik, accountDetails }) {
  const [openAddFinancial, setOpenAddFinancial] = useState(false);
  const { values } = formik;
  console.log(values);
  const toggleAddFinancial = () => {
    setOpenAddFinancial((prev) => !prev);
  };

  return (
    <Box>
      {/* <Block title={'Please select the account you would like to use'}> */}

      <RadioGroup name='themeMode'>
        <StyledWrap>
          {options.length > 0 ? (
            options.map((account, idx) => (
              <StyledCard key={idx} selected={values.account === account.id} onClick={toggleAddFinancial}>
                <Stack
                  sx={{
                    justifyContent: 'space-between',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: 2,
                  }}
                >
                  <SvgColor src={`/assets/icons/payments/${account.type}.svg`} />
                  <Stack>
                    <Typography variant='body1' sx={{ fontWeight: 500, whiteSpace: 'nowrap' }}>
                      {_.capitalize(account.display)}
                    </Typography>
                  </Stack>
                  <Divider orientation='vertical' flexItem />
                  <Tooltip title={'Edit'}>
                    <SvgColor src={`/assets/icons/edit.svg`} />
                  </Tooltip>
                </Stack>
                {/* <MaskControl value={account.id} /> */}
              </StyledCard>
            ))
          ) : (
            <StyledCard key={'add'} selected={false} onClick={toggleAddFinancial}>
              <SvgColor src={`/assets/icons/add.svg`} />
              <Stack sx={{ ml: 2 }}>
                <Typography variant='body1' sx={{ fontWeight: 500 }}>
                  {_.capitalize('Add New Account')}
                </Typography>
              </Stack>
              {/* <MaskControl value={account.id} /> */}
            </StyledCard>
          )}
        </StyledWrap>
      </RadioGroup>
      {openAddFinancial && (
        <AddFinancial
          open={openAddFinancial}
          financialType={values.payment_method}
          financialDetails={accountDetails || {}}
          onClose={toggleAddFinancial}
          isEdit={options.length !== 0}
        />
      )}
    </Box>
  );
}
